export const getLocalizedText = (data, field, language) => {
  if (!data?.[field]) return "";

  return (
    data[field]?.find((x) => x.language === language)?.text ||
    data[field]?.find((x) => x.language === "en")?.text ||
    ""
  );
};

export const getPopupContent = (popupData, language) => {
  return {
    header: getLocalizedText(popupData, "header", language),
    title: getLocalizedText(popupData, "title", language),
    description: getLocalizedText(popupData, "description", language),
    buttonTexts: getLocalizedText(popupData, "buttonTexts", language),
    countryCode: popupData?.organizationInfo?.organizationCountryCode,
  };
};
